import type { LucideIcon } from "lucide-react";

type IconBadgeProps = {
  icon: LucideIcon;
  size?: number;
};

// Иконка находки без героя и предмета: значок по смыслу находки в квадрате того же размера,
// что у иконок героев.
export const IconBadge = ({ icon: Icon, size = 44 }: IconBadgeProps) => (
  <span
    aria-hidden="true"
    style={{ width: size, height: size }}
    className="inline-flex shrink-0 items-center justify-center rounded-lg bg-surface-raised text-muted"
  >
    <Icon size={Math.round(size * 0.5)} strokeWidth={1.75} />
  </span>
);
